module.exports = __webpack_public_path__ + "static/Ninja-coder-final-0763353d35e4a2822b7c2351b274db6d.mp4";